const STORAGE_KEY = 'sshop:recent-searches';
const MAX_RECENT_SEARCHES = 8;

export function readSearchHistory(): string[] {
  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? '[]');
    return Array.isArray(stored)
      ? stored
          .filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
          .slice(0, MAX_RECENT_SEARCHES)
      : [];
  } catch {
    return [];
  }
}

export function rememberSearch(query: string): string[] {
  const value = query.trim();
  if (!value) return readSearchHistory();

  const recent = [
    value,
    ...readSearchHistory().filter((item) => item.toLocaleLowerCase() !== value.toLocaleLowerCase()),
  ].slice(0, MAX_RECENT_SEARCHES);

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
  } catch {
    // Search still works when local storage is unavailable.
  }
  return recent;
}

export function clearSearchHistory(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // The visible history can still be cleared for this session.
  }
}
